<!--
 * @Author: zl
 * @Date: 2022-03-29 08:57:34
 * @LastEditTime: 2022-12-16 10:57:22
 * @LastEditors: zl
 * @Description: 三方巡查资料
-->
<template>
	<div class="PatrolsDataIndex-layout filter-layout">
		<div class="filter-box pdt10">
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px">
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="片区"
									  prop="isNorth"
									  label-width="90px">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in areaOptions"
									  :class="{ 'active-span': searchForm.isNorth.join(',') == item.value }"
									  @click="searchClick(item, 'isNorth')">
									<TextTooltip :refName="item.value + 'isNorth'"
												 :content="item.sname"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="计划编排类别"
									  prop="start">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in typeOptions"
									  :class="{ 'active-span': searchForm.start == item.value }"
									  @click="searchClick(item, 'start')">
									<TextTooltip :refName="item.value + 'start'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="进展状况"
									  prop="progressStatus">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in stateOptions"
									  :class="{ 'active-span': searchForm.progressStatus == item.value }"
									  @click="searchClick(item, 'progressStatus')">
									<TextTooltip :refName="item.value + 'progressStatus'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="建设类型"
									  prop="constType"
									  label-width="90px">
							<div class="custom-box sp-box">
								<span :key="item.id"
									  class="text-overflow"
									  v-for="item in jsTypeOptions"
									  :class="{ 'active-span': searchForm.constType == item.value }"
									  @click="searchClick(item, 'constType')">
									<TextTooltip :refName="item.value + 'constType'"
												 :content="item.sname"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="时间维度"
									  prop="timeType">
							<div class="custom-box time-box">
								<span :key="item.id"
									  class="text-overflow"
									  v-for="item in timeOptions"
									  :class="{ 'active-time': searchForm.timeType == item.value, 'disabled': item.disabled }"
									  @click="searchClick(item, 'timeType')">
									<TextTooltip :refName="item.value + 'timeType'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="选择时间"
									  prop="time">
							<el-date-picker type="daterange"
											v-model="searchForm.time"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											range-separator="~"
											clearable
											disabled
											@change="timeChange"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="项目名称"
									  prop="projectName"
									  label-width="90px">
							<el-input v-model="searchForm.projectName"
									  placeholder="请输入项目名称"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="项目类型"
									  prop="newProType">
							<el-select v-model="searchForm.newProType"
									   placeholder="请选择表单类型"
									   clearable>
								<el-option v-for="item in projectDict.dxxmlx"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>

						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="建设单位"
									  prop="constructionUnit">
							<el-select v-model="searchForm.constructionUnit"
									   placeholder="请选择建设单位"
									   clearable>
								<el-option v-for="(item, index) in constructionUnitList"
										   :key="index + 'constructionUnitList'"
										   :label="item.sname"
										   :value="item.ownerUnit"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="表单类型"
									  prop="moduleType"
									  label-width="90px">
							<el-select v-model="searchForm.moduleType"
									   placeholder="请选择表单类型"
									   clearable>
								<el-option v-for="(item, index) in formTypeList"
										   :key="index"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="巡查类型"
									  prop="patrolType">
							<el-select v-model="searchForm.patrolType"
									   placeholder="请选择表单类型"
									   clearable>
								<el-option v-for="(item, index) in projectDict.dxxclx"
										   :key="item.value"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item class="text-right"
									  label-width="0">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="submitForm">查询</el-button>
							<el-button @click="resetForm"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="filter-content primary-layout">
			<h3 class="text-center pdt10 pdb10">东部新中心建设项目三方巡查资料</h3>
			<div class="primary-header">
				<div class="left-text">
					筛选时间统计: {{ tableObj.rangeTime }}
					<!-- <span class="tips">
						<i class="el-icon-warning"></i>
						统计期内{{ showMsg }}项目数： {{ tableObj.total }}个
					</span> -->
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="mini"
							   icon="el-icon-menu"
							   @click="doFilter">列过滤</el-button>
					<el-button size="mini">导出Excel</el-button>
				</div>
			</div>
			<div class="primary-content">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   highlight-hover-row
								   highlight-current-row
								   height="100%"
								   :loading="tableObj.loading"
								   ref="patrolsTable"
								   show-header-overflow="tooltip"
								   show-overflow="tooltip">
							<vxe-column title="序号"
										type="seq"
										width="65"></vxe-column>
							<vxe-column title="项目名称"
										field="projectName"
										min-width="200px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<span class="vxe-cell--label blue-text">
										{{ row.projectName }}
									</span>
								</template>
							</vxe-column>
							<vxe-column title="标段名称"
										field="packName"
										min-width="200px"
										header-align="center"
										align="left"
										:visible="false"></vxe-column>
							<vxe-column title="片区"
										field="isNorthName"
										width="80px"></vxe-column>
							<vxe-column title="建设单位"
										field="constructionUnitName"
										width="130px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.constructionUnitName"
												placement="top">
										<span class="vxe-cell--label">
											{{ row.constructionUnitShortName }}
										</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="计划编排类别"
										field="planType"
										width="120px"></vxe-column>
							<vxe-column title="项目类型"
										field="newProTypeName"
										width="130px"
										:visible="false"></vxe-column>
							<vxe-column title="建设类型"
										field="constructionTypeName"
										width="130px"
										:visible="false"></vxe-column>
							<vxe-column title="争取开工年份"
										field="striveStartDate"
										width="120px"
										:visible="false"></vxe-column>
							<vxe-column title="进展状态"
										field="progressStatusName"
										width="130px"
										:visible="false"></vxe-column>
							<vxe-column title="表单名称"
										field="sname"
										min-width="150px"
										header-align="center"
										align="left"></vxe-column>
							<vxe-column title="表单类型"
										field="moduleTypeName"
										min-width="150px"></vxe-column>
							<vxe-column title="巡查类型"
										field="patrolTypeName"
										width="100px"></vxe-column>
							<vxe-column title="三巡单位"
										field="patrolUnitName"
										width="130px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.patrolUnitName"
												placement="top">
										<span class="vxe-cell--label">
											{{ row.patrolUnitShortName }}
										</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="操作人"
										field="updateUserName"
										width="120px"></vxe-column>
							<vxe-column title="操作单位"
										field="tenantShortName"
										width="130px"
										header-align="center"
										align="left"
										:visible="false">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.tenantName"
												placement="top">
										<span class="vxe-cell--label">
											{{ row.tenantShortName }}
										</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="操作日期"
										field="updateDate"
										width="120px">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.updateDate"
												:disabled="!row.updateDate"
												placement="top">
										<span class="vxe-cell--label"
											  v-if="!!row.updateDate">
											{{ row.updateDate.substr(0, 11) }}
										</span>
										<span v-else>-</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="操作"
										width="180px">
								<template #default="{ row }">
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   @click="doClick(row, 'view')">
										<svg-icon icon-class="form-look"></svg-icon> 查看
									</el-button>
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   @click="doClick(row, 'enter')">
										<svg-icon icon-class="form-enter"></svg-icon> 进入项目
									</el-button>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
					<div class="w-table-pager">
						<vxe-pager :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :total="tableObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   align="center"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</div>
		</div>

		<!-- 查看 -->
		<PatrolsView v-if="dialogObj.show"
					 ref="PatrolsView"
					 :currentRow="dialogObj.data"
					 @sendClose="acceptClose"></PatrolsView>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getContainerParams } from '@/api/home/homeIndex'
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/Patrols/PatrolsIndex'
import PatrolsView from '@/views/PatrolsData/PatrolsView'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
export default {
	name: 'PatrolsDataIndex',
	components: { PatrolsView, ColumnFilter, TextTooltip },
	data() {
		return {
			searchForm: {
				timeType: 2,
				time: [],
				startTime: '', //选择开始时间
				endTime: '', //选择结束时间
				projectName: '', //工程项目名称
				newProType: '', //项目类型
				isNorth: [], //所在区域
				start: '0,1,2', //计划编排类别
				constructionUnit: '',
				constType: 'all', //建设类型
				sname: '', //表单名称
				moduleType: '', //表单类型
				progressStatus: 'all', //进展状况
				patrolType: '', //巡查类型
			},
			tableObj: {
				rangeTime: '',
				loading: false,
				data: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			constructionUnitList: [], //建设单位列表
			isNorth: true,
			dialogObj: {
				show: false,
				data: {},
			},
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
		}
	},
	created() {
		this.searchForm.isNorth = this.projectDict.xmgsqy.map((x) => x.value)
		// 获取当前时间
		this.getContainerParams()
		// 根据单位类型查询单位
		this.getCompanyList()
		setTimeout(() => {
			let tableColumn = this.$refs.patrolsTable.getTableColumn()
			tableColumn.collectColumn.shift()
			tableColumn.collectColumn.pop()
			this.filterColumns[0].columns = tableColumn.collectColumn
		}, 1500)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.patrolsTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.patrolsTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// 获取当前时间
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let now = res.data.currentDate
				let start = this.$utils.getWhatMonth(now, 0, 'first')
				let end = this.$utils.getWhatMonth(now, 0, 'last')
				start = this.$utils.toDateString(start, 'yyyy-MM-dd')
				end = this.$utils.toDateString(end, 'yyyy-MM-dd')
				this.searchForm.startTime = start
				this.searchForm.endTime = end
				this.tableObj.rangeTime = start + ' 至 ' + end
				this.searchForm.time = [start, end]
				this.getPatrolsData()
			})
		},

		// search 区域点击事件
		searchClick(data, type) {
			if (type == 'timeType') {
				return
			}
			if (type == 'isNorth') {
				this.searchForm[type] = []
				if (Array.isArray(data.value)) {
					this.searchForm[type] = data.value
				} else {
					this.searchForm[type].push(data.value)
				}
				this.getPatrolsData()
				return
			}
			this.searchForm[type] = data.value
			this.getPatrolsData()
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		// 获取形象进度列表数据
		getPatrolsData() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.time
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			this.tableObj.loading = true
			API.selTripartiteInspectionPageList(params)
				.then((res) => {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 选择时间 change 事件
		timeChange(data) {
			if (!data) {
				this.searchForm.startTime = ''
				this.searchForm.endTime = ''
				this.tableObj.rangeTime = ''
				return
			}
			this.searchForm.startTime = data[0]
			this.searchForm.endTime = data[1]
			this.tableObj.rangeTime = data[0] + ' 至 ' + data[1]
		},

		// 合计 change
		checkBoxChange(data) {
			this.searchForm.isNorth = !data
				? []
				: this.projectDict.xmgsqy.map((x) => x.value)
		},

		// 表单搜索
		submitForm() {
			this.tableObj.currentPage = 1
			this.getPatrolsData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.isNorth = this.projectDict.xmgsqy.map(
				(x) => x.value
			)
			this.tableObj.currentPage = 1
			this.getContainerParams()
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getPatrolsData()
		},

		// 表格按钮点击事件
		doClick(data, type) {
			if (type == 'enter') {
				let url = this.$outUrl
				let token = this.$getSessionItem('token')
				let tenantId = this.$getSessionItem('tenantId')
				let limitId = this.$getSessionItem('limitId')
				ProjectApi.getAuditWorkPower({
					projectId: data.projectId,
				}).then((res) => {
					if (res.operationCode == 1 && res.msg == 'faild') {
						this.$message.warning(res.data)
						return
					}
					window.open(
						`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
						'_blank'
					)
				})
				return
			}
			this.dialogObj.show = true
			this.dialogObj.data = this.$utils.clone(data, true)
			setTimeout(() => {
				this.$refs.PatrolsView.dialogObj.show = true
			}, 200)
		},

		// 接受弹窗关闭
		acceptClose(data) {
			this.dialogObj.show = data
			this.dialogObj.data = {}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		// 时间维度
		timeOptions() {
			let arr = [
				{
					label: '昨日',
					disabled: true,
					value: 0,
				},
				{
					label: '今日',
					disabled: true,
					value: 1,
				},
				{
					label: '本月',
					disabled: false,
					value: 2,
				},
				{
					label: '本季度',
					disabled: true,
					value: 3,
				},
				{
					label: '本年',
					disabled: true,
					value: 4,
				},
			]
			return arr
		},

		// 表单类型
		formTypeList() {
			let arr = [
				{ id: '1', sname: '安全巡查交底表' },
				{ id: '2', sname: '月度巡查计划表' },
				{ id: '3', sname: '工程巡查意见书' },
				{ id: '4', sname: '工程巡查报告' },
				{ id: '5', sname: '工程巡查月报' },
				{ id: '6', sname: '工程巡查报告回复单' },
				{ id: '8', sname: '工程巡查处罚单' },
			]
			return arr
		},

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '全部',
					value: '0,1,2',
					id: '100085',
				},
				{
					label: '新建项目',
					value: '0',
					id: '100086',
				},
				{
					label: '开展前期',
					value: '1',
					id: '100087',
				},
				{
					label: '续建项目',
					value: '2',
					id: '100088',
				},
			]
			return arr
		},

		// 进展状况
		stateOptions() {
			let arr = [
				{
					label: '全部',
					value: 'all',
					id: '10001',
				},
				{
					label: '未开工',
					value: '0',
					id: '10002',
				},
				{
					label: '已开工',
					value: '1',
					id: '10003',
				},
				{
					label: '竣工',
					value: '2',
					id: '10004',
				},
			]
			return arr
		},

		// 建设类型
		jsTypeOptions() {
			let arr = this.$utils.clone(this.projectDict.dxjslx, true)
			let obj = {
				sname: '全部',
				value: 'all',
			}
			if (arr) {
				arr.unshift(obj)
			}
			return arr
		},

		// 片区
		areaOptions() {
			let arr = this.$utils.clone(this.projectDict.xmgsqy, true)
			let obj = {
				sname: '全部',
				value: '',
			}
			if (arr) {
				obj.value = arr.map((x) => x.value)
				arr.unshift(obj)
			}
			return arr
		},

		// 提示信息
		showMsg() {
			let area = this.areaOptions.find(
				(x) => x.value == this.searchForm.isNorth
			)
			let type = this.typeOptions.find(
				(x) => x.value == this.searchForm.start
			)
			let progress = this.stateOptions.find(
				(x) => x.value == this.searchForm.progressStatus
			)
			return area.sname + type.label + progress.label
		},
	},
	watch: {
		'searchForm.isNorth': {
			handler(val, oldval) {
				this.isNorth = val.length == 3 ? true : false
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.PatrolsDataIndex-layout {
	height: 100%;
	.el-checkbox {
		margin-right: 15px;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
		margin-left: 30px;
	}
	.custom-box {
		display: flex;
		span + span {
			margin-left: 10px;
		}
		span:hover {
			background-color: #2cbdfc;
			color: #fff;
		}
	}
	.custom-box > * {
		flex: 1;
		text-align: center;
		height: 28px !important;
		line-height: 30px !important;
		font-size: 12px;
		background-color: #f2f2f2;
		color: #868686;
		cursor: pointer;
	}
	.sp-box > * {
		flex: inherit;
		padding: 0 13px;
	}
	.sp-box span:first-child {
		padding: 0 15px !important;
	}
	.active-span {
		background-color: #2cbdfc !important;
		color: #fff !important;
	}
	.time-box > * {
		height: 32px !important;
		line-height: 32px !important;
	}
	.time-box {
		span {
			border: 1px solid #eee;
			background-color: #fff;
			color: #333;
		}
		span + span {
			margin-left: 0px !important;
		}
		.active-time {
			background-color: #2cbdfc !important;
			color: #fff !important;
			border: 1px solid #2cbdfc !important;
		}
		span:first-child {
			border-top-left-radius: 3px;
			border-bottom-left-radius: 3px;
		}
		span:last-child {
			border-top-right-radius: 3px;
			border-bottom-right-radius: 3px;
		}
		.disabled {
			cursor: not-allowed !important;
			background-color: #fafafa;
			color: #868686;
		}
		.disabled:hover {
			border: 1px solid #eee;
			background-color: #fafafa;
			color: #868686;
		}
	}
}
</style>